import { formatSimpleDate } from "@dune/utils";
import { ColumnDef } from "@tanstack/react-table";
import { Check } from "@untitled-ui/icons-react";
import { RegisterSecondStepDetailsFormData } from "./UseRegisterSecondStepBroker";

type Category = NonNullable<
	RegisterSecondStepDetailsFormData["categories"]
>[number];

export const categoriesColumns: ColumnDef<Category>[] = [
	{
		accessorKey: "category",
		header: "Catégorie",
		cell: ({ row }) => (
			<div className="truncate min-w-0" title={row.original.category}>
				{row.original.category}
			</div>
		),
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			const isRegistered = row.original.status === "REGISTERED";
			return (
				<div
					className={`inline-flex px-2 py-1 rounded-full text-xs sm:text-sm text-center border whitespace-nowrap ${
						isRegistered
							? "text-green-800 bg-green-50 border-green-300"
							: "text-red-800 bg-red-50 border-red-300"
					}`}
				>
					{isRegistered ? "Inscrit" : "Non inscrit"}
				</div>
			);
		},
	},
	{
		accessorKey: "registrationDate",
		header: "Date d'inscription",
		cell: ({ row }) => (
			<div className="whitespace-nowrap text-sm">
				{formatSimpleDate(row.original.registrationDate)}
			</div>
		),
	},
	{
		accessorKey: "categoryDeletionDate",
		header: "Date suppression catégorie",
		cell: ({ row }) => (
			<div className="whitespace-nowrap text-sm">
				{row.original.categoryDeletionDate
					? formatSimpleDate(row.original.categoryDeletionDate)
					: "—"}
			</div>
		),
	},
	{
		accessorKey: "fundCollection",
		header: "Encaissement de fonds",
		cell: ({ row }) => (
			<div className="text-center">
				{row.original.fundCollection ? <Check className="inline-block" /> : "—"}
			</div>
		),
	},
	{
		accessorKey: "mandants",
		header: "Mandants",
		cell: ({ row }) => (
			<div className="truncate min-w-0" title={row.original.mandants || "—"}>
				{row.original.mandants || "—"}
			</div>
		),
	},
];
